import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskReserveDetailInterface } from '../definitions/task-reserve-detail-interface';

@Injectable()
export class TaskReservesListService {
  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public list(taskId: string): Observable<TaskReserveDetailInterface[]> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/reserves`;

    return this.client.get<TaskReserveDetailInterface[]>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
